import { defineComponent as _defineComponent } from 'vue'
import { createIcon } from '@download/blockies';
import { ref, toRefs, watch } from '@nuxtjs/composition-api';

interface Props {
    alt?: string,
    size?: 'm' | 'l' | 'xl' | 's' | 'm-h' | 'l-h' | 'xl-h' | 's-h' | 'm-w' | 'l-w' | 'xl-w' | 's-w',
    rounded?: boolean,
    disabled?: boolean,
    active?: boolean,
    address: string,
    blockiesConfig?: {
        seed?: string,
        size?: number,
        scale?: number,
        color?: string,
        bgColor?: string,
    },
}


const blockiesCache = new Map();

export default /*#__PURE__*/_defineComponent({
  __name: 'BlockiesAvatar',
  props: {
    alt: null,
    size: { default: 'm' },
    rounded: { type: Boolean },
    disabled: { type: Boolean },
    active: { type: Boolean },
    address: null,
    blockiesConfig: null
  },
  setup(__props: any) {

const props = __props as { alt?: string, size: 'm' | 'l' | 'xl' | 's' | 'm-h' | 'l-h' | 'xl-h' | 's-h' | 'm-w' | 'l-w' | 'xl-w' | 's-w', rounded?: boolean, disabled?: boolean, active?: boolean, address: string, blockiesConfig?: {
        seed?: string,
        size?: number,
        scale?: number,
        color?: string,
        bgColor?: string,
    } };



const {
    address,
    size,
    alt,
    disabled,
    active,
    rounded,
} = toRefs(props);

const src = ref('');

watch(address, () => {
    if (blockiesCache.has(address.value)) {
        src.value = blockiesCache.get(address.value);
    } else {
        const config = Object.assign({ seed: address.value }, props.blockiesConfig);
        const canvas = createIcon(config);
        src.value = canvas.toDataURL();
        blockiesCache.set(address.value, src.value);
    }
}, { immediate: true });


return { __sfc: true,blockiesCache, props, address, size, alt, disabled, active, rounded, src }
}

})